$(function () {

    /**
     * LIGHTBOX
     */

    $(document).on('click', '.lightbox-close', function (e) {
        e.preventDefault();
        $('.lightbox-product').remove();
        $('body').css('overflow', '');
    });

    $(document).on('click', '.lightbox-container', (e) => {
        if (!$(e.target).closest('.lightbox-content').length && $('.lightbox-container').hasClass('open')) {
            e.preventDefault();
            $('.lightbox-close').trigger('click');
        }
    });

    $(document).on('click', '.btn_continue', function (e) {
        e.preventDefault();
        $('.lightbox-close').trigger('click');
    });

    /**
     * FIN - LIGHTBOX
     */

});

